import { useMemo, useState } from "react";
import { series, seriesGenres } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

const seriesRegions = ["全部地区", "中国大陆", "美国", "韩国", "日本"];

export default function SeriesSection() {
  const [region, setRegion] = useState("全部地区");
  const [genre, setGenre] = useState("全部");

  const filtered = useMemo(
    () =>
      series.filter((item) => {
        const matchRegion = region === "全部地区" || item.region === region;
        const matchGenre = genre === "全部" || item.genre === genre;
        return matchRegion && matchGenre;
      }),
    [region, genre],
  );

  return (
    <section id="series" className="scroll-mt-24 bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="TV SERIES"
          title="电视剧片库：热播剧与完结剧集资源全收录"
          desc="片库按地区与类型整理电视剧集，标注更新进度与完结状态。连载中的剧集能看到当前更新集数，已完结的可以放心一次看完整季。"
        />

        <div className="mt-8 flex flex-col gap-4 rounded-lg border border-background-200/70 bg-background-100 p-4 md:flex-row md:items-center md:justify-between">
          <div className="flex flex-wrap gap-2" role="tablist" aria-label="电视剧类型筛选">
            {seriesGenres.map((item) => {
              const isActive = genre === item;
              return (
                <button
                  key={item}
                  type="button"
                  role="tab"
                  aria-selected={isActive}
                  onClick={() => setGenre(item)}
                  className={`whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm font-medium transition-colors ${
                    isActive
                      ? "bg-secondary-500 text-background-50"
                      : "bg-background-50 text-foreground-700 hover:bg-secondary-100 hover:text-secondary-900"
                  }`}
                >
                  {item}
                </button>
              );
            })}
          </div>
          <div className="flex flex-wrap gap-2">
            {seriesRegions.map((item) => {
              const isActive = region === item;
              return (
                <button
                  key={item}
                  type="button"
                  onClick={() => setRegion(item)}
                  className={`whitespace-nowrap rounded-md px-3 py-1.5 text-xs font-medium transition-colors ${
                    isActive
                      ? "bg-foreground-950 text-background-50"
                      : "border border-background-300/70 text-foreground-600 hover:border-secondary-300 hover:text-secondary-800"
                  }`}
                >
                  {item}
                </button>
              );
            })}
          </div>
        </div>

        <div className="mt-6 flex flex-col gap-4">
          {filtered.map((item) => (
            <article
              key={item.id}
              className="group flex flex-col gap-4 rounded-lg border border-background-200/70 bg-background-50 p-4 transition-colors hover:border-secondary-300 sm:flex-row"
            >
              <div className="h-56 w-full shrink-0 overflow-hidden rounded-md sm:h-40 sm:w-28">
                <img
                  src={item.poster}
                  alt={`${item.title} 剧集海报`}
                  title={`${item.title} 剧集海报`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>

              <div className="flex min-w-0 flex-1 flex-col justify-between">
                <div>
                  <div className="flex flex-wrap items-center gap-2">
                    <h3 className="font-heading text-lg font-bold text-foreground-950">{item.title}</h3>
                    <span className="flex items-center gap-1 rounded-full bg-accent-100 px-2 py-0.5 font-label text-xs font-bold text-accent-800">
                      <i className="ri-star-fill"></i>
                      {item.rating}
                    </span>
                    <span
                      className={`rounded-full px-2.5 py-0.5 font-label text-xs font-medium ${
                        item.status === "连载中"
                          ? "bg-primary-100 text-primary-800"
                          : "bg-secondary-100 text-secondary-900"
                      }`}
                    >
                      {item.status}
                    </span>
                  </div>
                  <p className="mt-2 text-xs text-foreground-500">
                    {item.meta} · {item.region} · {item.year}
                  </p>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                </div>
                <div className="mt-4 flex flex-wrap items-center justify-between gap-3 border-t border-background-200/70 pt-3">
                  <span className="flex items-center gap-1.5 text-xs font-medium text-secondary-800">
                    <i className="ri-play-list-2-line"></i>
                    {item.episodes}
                  </span>
                  <a
                    href="#ranking"
                    className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 hover:text-primary-800"
                  >
                    查看榜单表现
                    <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}